import { Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Level } from 'theme/enums';

interface IProps {
  isError?: boolean;
}

// The grid shows this whenever it holds no rows, which a failed list request also produces — hence
// the two messages: "no mappings" would otherwise state as fact something that was never loaded.
export const NoRowsOverlay = ({ isError = false }: IProps) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ height: '100%', justifyContent: 'center', alignItems: 'center' }}>
      <Typography level={Level.TITLE_MD} sx={{ fontWeight: 500, textAlign: 'center' }}>
        {t(isError ? 'errorTitleDataLoading' : 'messageNoExtractorVendorMappings')}
      </Typography>
    </Stack>
  );
};
